import React from "react";
import PropTypes from 'prop-types';
import {findDOMNode} from "react-dom";

import AccountOption from "../options/account-option";
import ContactOption from "../options/contact-option";

export default class CRMSearchList extends React.Component {

    static propTypes = {
        type: PropTypes.oneOf(['remove-contact', 'contact', 'account']),
        accountId: PropTypes.string,
        items: PropTypes.array,

        currentOptionKey: PropTypes.string,

        onClickOption: PropTypes.func,
        onAddClick: PropTypes.func,
    }

    constructor(props) {
        super(props);

        this.optionsReference = {};
    }

    componentDidUpdate() {
        const key = this.props.currentOptionKey;

        if (this.optionsReference[key]) {
            const mainNode = findDOMNode(this.main);
            const node = findDOMNode(this.optionsReference[key]);
            mainNode.scrollTop = node.offsetTop - (mainNode.clientHeight - node.clientHeight)/2;
        }
    }

    render() {
        const noMatches = !this.props.items || this.props.items.length === 0;

        let OptionComponent, addLabel;
        switch (this.props.type) {
            case 'account'          :
                OptionComponent = AccountOption
                addLabel        = "+ New CRM Company"
                break

            case 'remove-contact'   :
            case 'contact'          :
                OptionComponent = ContactOption
                addLabel        = "+ New CRM Contact"
                break
        }

        return (
            <div ref={r=>this.main = r} className="crm-list">
                {this.props.accountId &&
                    <div className="ui5-title-small fl-ac m-b-10">
                        {gd.session.crmAccounts.get(this.props.accountId).name}:
                    </div>}

                <div className="ui5-list h-40 m-b-20">
                    {_.map(this.props.items, model=>
                        <OptionComponent key={model.id}
                                         ref={r=>this.optionsReference[model.id] = r}
                                         type={this.props.type}
                                         model={model}
                                         isSelected={model.id === this.props.currentOptionKey}
                                         onClick={this.props.onClickOption}/>)}

                    {noMatches &&
                        <div className="row not-found">
                            <div className="ui5-txt-no-accent-default">No match found</div>
                        </div>}

                    {this.props.type !== 'remove-contact' &&
                        <div className="row row-add" onClick={this.props.onAddClick}>
                            <div className="ui5-link-default max-w-250">{addLabel}</div>
                        </div>}
                </div>
            </div>
        )
    }
}
